module.exports = __webpack_public_path__ + "img/logo.9f64cb4c.svg";